import React from 'react'

export const ZebraShape = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="223"
    height="205"
    viewBox="0 0 223 205"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M129.984 191.43C121.549 199.654 112.466 203.981 102.731 204.408C91.5159 204.771 80.5084 200.159 69.71 190.572C59.0501 181.108 53.5134 171.031 53.0996 160.344C52.4916 150.715 56.0307 141.069 63.7148 131.404L129.984 191.43ZM191.141 120.94L139.97 180.238L116.369 158.861L167.495 99.5222L191.141 120.94ZM149.25 82.9968L97.2617 141.553L73.5908 120.113L125.58 61.5564L149.25 82.9968ZM45.4834 114.89L23.8809 139.058L0 117.855L21.8125 93.45L45.4834 114.89ZM222.072 85.0984L200.943 109.582L177.288 88.156L198.191 63.8963L222.072 85.0984ZM107.664 45.3289L55.4795 103.708L31.8086 82.2673L83.9902 23.8855L107.664 45.3289ZM120.612 0.229263C131.901 -1.05234 142.875 3.03929 153.535 12.5037C164.056 21.845 169.349 32.1961 169.413 43.5564C169.354 52.5472 165.84 61.8541 158.878 71.4802L128.15 43.6472C127.629 43.031 127.039 42.4267 126.377 41.8386C125.779 41.3078 125.183 40.8374 124.591 40.4236L94.3867 13.0652C102.883 5.51683 111.624 1.23804 120.612 0.229263Z" />
  </svg>
)
